module.exports = __webpack_public_path__ + "img/3.114c5b72.jpg";